document.addEventListener('DOMContentLoaded', () => {
  window.incrementQuantity = function(element) {
    const input = element.parentElement.querySelector('.quantity-input');
    const max = input.getAttribute('max');
    const currentValue = parseInt(input.value);
    if (!max || currentValue < parseInt(max)) {
      input.value = currentValue + 1;
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  window.decrementQuantity = function(element) {
    const input = element.parentElement.querySelector('.quantity-input');
    const currentValue = parseInt(input.value);
    if (currentValue > 1) {
      input.value = currentValue - 1;
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  var width_screen = window.innerWidth;
  if (width_screen < 750) {
    var menuFooter = document.querySelectorAll('.footer__wrapper .footer__block-list .footer__block.footer__block--menu p');
    for (var i = 0; i < menuFooter.length; i++) {
      menuFooter[i].addEventListener('click', function(event) {
        var currentTarget = event.target;
        if ( currentTarget.classList.contains("active") === false ){
          currentTarget.classList.add("active");
        }else{
          currentTarget.classList.remove("active");
        }
      });
    }
  }
  
});